import Image from "next/image";
import { useState } from "react";
import styles from "./UseCases.module.scss";

const cases = [
	{
		btn: "photography",
		description: "photography_description",
		picBefore: "1-1.png",
		picAfter: "1-2.png",
	},
	{
		btn: "text_watermarks",
		description: "text_watermarks_description",
		picBefore: "2-1.png",
		picAfter: "2-2.png",
	},
	{
		btn: "interior",
		description: "interior_description",
		picBefore: "3-1.png",
		picAfter: "3-2.png",
	},
	{
		btn: "e_commerce",
		description: "e_commerce_description",
		picBefore: "4-1.png",
		picAfter: "4-2.png",
	},
];

const UseCases = ({ dictionary }) => {
	const [activeCase, setActiveCase] = useState(cases[0]);

	const handleChangeCase = (index) => {
		setActiveCase(cases[index]);
	};

	return (
		<section className={styles.container}>
			<h2 className={styles.title}>{dictionary["page_erase_header_use_cases"]}</h2>
			<div className={styles.btns_wrapper}>
				{cases.map(({ btn }, index) => (
					<button onMouseEnter={() => handleChangeCase(index)} key={btn} className={`${styles.btn} ${btn === activeCase.btn ? styles.active : styles.not_active}`}>
						{dictionary[btn]}
					</button>
				))}
			</div>
			<p className={styles.description}>{dictionary[activeCase.description]}</p>

			<div className={styles.photo_wrapper}>
				<Image src={`/erase_and_replace/cases/${activeCase.picBefore}`} alt={"Image before"} width="714" height="500" className={styles.image} />
				<Image src={`/erase_and_replace/cases/${activeCase.picAfter}`} alt={"Image after"} width="714" height="500" className={styles.image} />
			</div>
			<div className={styles.adaptiveWrapper}>
				{cases.map((item) => (
					<div className={styles.case} key={dictionary[item.btn]}>
						<p className={styles.name}>{dictionary[item.btn]}</p>
						<p className={styles.text}>{dictionary[item.description]}</p>
						<div className={styles["image-wrapper"]}>
							<Image src={`/erase_and_replace/cases/${item.picBefore}`} alt={"Image before"} className={styles.before} width={180} height={180} loading="lazy" />
							<Image src={`/erase_and_replace/cases/${item.picAfter}`} alt={"Image after"} className={styles.after} width={180} height={180} loading="lazy" />
						</div>
					</div>
				))}
			</div>
		</section>
	);
};

export default UseCases;
